export enum ProValidationErrorWarningType {
  ProHasStatus = 'proHasStatus',
  UnbilledPro = 'unbilledPro',
  DuplicateClaim = 'duplicateClaim',
  DuplicatePro = 'duplicatePro',
  InvalidProFormat = 'invalidProFormat',
  NonRevPro = 'nonRevPro',
}
